import { NavigationGuardNext, Route } from 'vue-router'

import store from '@/store'
import { getRequiredUserTypesFromRoute, isUserHasTypes } from '@/utils/permissions-helper'

async function checkUserTypeGuard(to: Route, from: Route, next: NavigationGuardNext) {
  if (!store.getters['auth/isAuthenticated']) {
    return next()
  }

  const requiredTypes: Array<Array<string>> = getRequiredUserTypesFromRoute(to)

  const isUserHasType = store.getters['permissions/isUserHasType']
  if (requiredTypes?.length && !isUserHasTypes(requiredTypes, isUserHasType)) {
    if (store.getters['permissions/isWaiter'] || store.getters['permissions/isChef']) {
      return next({ name: 'admin:orders' })
    }
    return next({ name: 'unauthorized' })
  }

  return next()
}

export default checkUserTypeGuard
